export default {
  days: null,
  ready: false,
  modal: false,
};



// WEBPACK FOOTER //
// ./assets/js/timetable/store/state.js